(function() {
    window.tournamentService = {
      get() {
        return axios.get('/api/tournament/get.php');
      },
      getActive(){
        return axios.get('/api/tournament/get.php?active=true');
      },
      getOpen(){
        return axios.get('/api/tournament/get.php?isopen=true');
      },
      save(data) {
        data.twitchId = utils.cookies.get('user_id');
        return axios.post('/api/tournament/save.php', data);
      },
      toggleOpenCloseTournament(data){
        return axios.post('/api/tournament/save.php', data);
      },
      getTournamentPlayer(id, event){
        return axios.get(`/api/tournament/players.php?id=${id}&&events=${event}`);
      },
      getTournamentQueue(){
        return axios.get(`/api/user/tournament/get.php?queue=true&&option=single`);
      },
      getTournamentTeamQueue(){
        return axios.get(`/api/user/tournament/get.php?queue=true&&option=team`);
      },
      saveTournamentBattle(data){
        return axios.post(`/api/user/tournament/save.php`, data);
      },
      checkTournament(id){
        return axios.get(`/api/user/tournament/get.php?id=${id}&&option=single`);
      },
      tournamentEvent(id){
        return axios.get(`/api/user/tournament/get.php?id=${id}&&option=single&&event=true`);
      },
      checkTeamTournament(id){
        return axios.get(`/api/user/tournament/get.php?id=${id}&&option=team`);
      },
      getTournamentEventQueue(id){
        return axios.get(`/api/user/tournament/get.php?queue=true&&option=single&&event=true`);
      },
      confirmChampion(data){
        return axios.post('/api/tournament/save.php', data);
      }
    }
  })();